import {
  paychexPerksWorkerTypes,
  paychexWorkerStatuses,
} from "statics/paychexWorkerTypes";
import type { PaychexWorkerRecord } from "types/models/paychexWorkerRecord";

export const isSplitEligibleWorkerRecord = (record: PaychexWorkerRecord) =>
  record.workerType === paychexPerksWorkerTypes.EMPLOYEE &&
  record.status !== paychexWorkerStatuses.INACTIVE;
